import { useTranslation } from "react-i18next";
import time from "src/utils/time";
import { Box, Flex } from "@chakra-ui/react";
import { Caption, Subtitle } from "src/atoms/typography";

export default function StartEvent({ startTimeColumnWidth, startDate }) {
  const { t } = useTranslation();
  return (
    <Flex alignItems="center" width="100%">
      <Caption
        textAlign="right"
        flex="0 0 auto"
        mr="20px"
        color="mediumEmphasis"
        width={startTimeColumnWidth + "px"}
      >
        {time(startDate).format("LT")}
      </Caption>
      <Box mr="20px" p="6px" bg="outline" borderRadius="100%" flexShrink={0} />
      <Subtitle
        color="highEmphasis"
        maxWidth={`calc(100% - ${startTimeColumnWidth}px - 20px - 12px - 20px);`}
      >
        {t("monitoringStarted")}
      </Subtitle>
    </Flex>
  );
}
